import validate from "/home/runner/work/pool-craft/pool-craft/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/home/runner/work/pool-craft/pool-craft/middleware/route.global.ts";
import manifest_45route_45rule from "/home/runner/work/pool-craft/pool-craft/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}